<app-alert></app-alert>

<div class="row mt-2">
    <div class="form-group col mb-n1">
        <h1>Discount Codes</h1>
    </div>
    <div class="form-group col mb-n1 flx-center">
        <a class="btn btn-primary btn-sm float-right" [routerLink]="['/offer/discount-new']">New Voucher</a>
    </div>
</div>

<div class="card mb-3 mt-2">
    <div class="card-body bg-light p-3">
        <div class="input-group input-group-sm w-lg-50">
            <div class="input-group-prepend">
                <span class="input-group-text bg-secondary text-light">Filter</span>
            </div>
            <input class="form-control" placeholder="Search" type="text" autofocus="autofocus" (keyup)="tableFiltring($event)" />
        </div>
    </div>
</div>

<ngx-datatable
    #table
    class="bootstrap-table"
    [rows]="items"
    [headerHeight]="61"
    [footerHeight]="38"
    [rowHeight]="'auto'"
    [columnMode]="'standard'"
    [scrollbarH]="true"
    [count]="totalItems"
    [offset]="0"
    [limit]="20"
>
    <ngx-datatable-column
        name="Discount Value"
        prop="dicountValue"
        [cellClass]="'tb-col-2'"
        [headerClass]="'tb-col-2'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div>
                <span> {{ value }}% </span>
                <span class="badge badge-success table-badge" *ngIf="row.isUsed"> Used </span>
            </div>
            <div class="cells-mobile">
                <div class="cell-value-line">{{ row.dicountCode }}</div>
                <div class="cell-value-line">{{ row.createdDate | date: 'MM/dd/yyyy, hh:mm a' }}</div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Discount Code"
        prop="dicountCode"
        [cellClass]="'tb-col-4 mobile-hide'"
        [headerClass]="'tb-col-4 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        name="Created Date"
        prop="createdDate"
        [cellClass]="'tb-col-4 mobile-hide'"
        [headerClass]="'tb-col-4 mobile-hide'"
        [draggable]="false"
        [resizeable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            {{ value | date: 'MM/dd/yyyy, hh:mm a' }}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column
        [cellClass]="'actions-cell tb-col-2'"
        [headerClass]="'actions-cell tb-col-2'"
        [draggable]="false"
        [resizeable]="false"
        [sortable]="false"
    >
        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
            <div class="btn-group ml-2" ngbDropdown container="body">
                <button type="button" class="btn btn-secondary btn-sm dropdown-toggle" ngbDropdownToggle>Actions</button>
                <div class="dropdown-menu" ngbDropdownMenu>
                    <a class="dropdown-item btn-sm" (click)="confirmDelete(row)" ngbDropdownItem>Delete</a>
                </div>
            </div>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-footer>
        <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-curPage="curPage">
            <datatable-pager
                [pagerLeftArrowIcon]="'datatable-icon-left'"
                [pagerRightArrowIcon]="'datatable-icon-right'"
                [pagerPreviousIcon]="'datatable-icon-prev'"
                [pagerNextIcon]="'datatable-icon-skip'"
                [page]="curPage"
                [size]="pageSize"
                [count]="rowCount"
                [hidden]="!(rowCount / pageSize > 1)"
                (change)="table.onFooterPage($event)"
            >
            </datatable-pager>
        </ng-template>
    </ngx-datatable-footer>
</ngx-datatable>
